import type { CityConfig } from "../city-template/types";

export const kernersvilleConfig: CityConfig = {
  city: "Kernersville",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "kernersville",
  route: "/cities/kernersville",
  title: "Emergency Passport Kernersville, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Kernersville, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Forsyth County and the Piedmont Triad. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Kernersville, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Kernersville and Piedmont Triad travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Kernersville%20North%20Carolina%20charming%20suburban%20downtown%20at%20golden%20hour%20with%20tree-lined%20streets%20and%20historic%20storefronts%2C%20modern%20suburban%20neighborhoods%20with%20green%20lawns%2C%20warm%20sunset%20light%20over%20the%20Piedmont%20Triad%20between%20Winston-Salem%20and%20Greensboro%2C%20clean%20blue%20sky%20with%20soft%20clouds%2C%20professional%20landscape%20photography%20with%20warm%20earthy%20tones%20and%20suburban%20southern%20charm%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=kernersville-hero-nc-001&orientation=landscape",
  heroImageAlt: "Kernersville North Carolina suburban downtown with tree-lined streets and warm sunset light in the Piedmont Triad",
  geoPosition: "36.1199;-80.0737",
  geoPlacename: "Kernersville, North Carolina",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 310 miles from Kernersville via I-85",
  },
  nearbyCitiesZips: [
    { name: "Kernersville", zips: "27284, 27285" },
    { name: "Winston-Salem", zips: "27101–27199" },
    { name: "Greensboro", zips: "27401–27499" },
    { name: "High Point", zips: "27260, 27261, 27262, 27263, 27265" },
    { name: "Thomasville", zips: "27360, 27361" },
    { name: "Archdale", zips: "27263" },
    { name: "Jamestown", zips: "27282" },
    { name: "Trinity", zips: "27370" },
    { name: "Clemmons", zips: "27012" },
    { name: "Lewisville", zips: "27023" },
    { name: "Walkertown", zips: "27051" },
    { name: "Asheboro", zips: "27203, 27204, 27205" },
    { name: "Burlington", zips: "27215, 27216, 27217" },
    { name: "Reidsville", zips: "27320, 27323" },
    { name: "Eden", zips: "27288, 27289" },
    { name: "Mebane", zips: "27302" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Forsyth County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Piedmont Triad Hub", desc: "Serving Kernersville, Winston-Salem, Greensboro, and the entire Triad" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Winston-Salem, NC", route: "/cities/winston-salem" },
    { name: "Fast passport renewal in Greensboro, NC", route: "/cities/greensboro" },
    { name: "Emergency passport help in High Point, NC", route: "/cities/high-point" },
    { name: "Urgent passport services in Charlotte, NC", route: "/cities/charlotte" },
    { name: "Same-day passport help in Raleigh, NC", route: "/cities/raleigh" },
    { name: "Passport courier services in Durham, NC", route: "/cities/durham" },
    { name: "Fast passport renewal in Asheboro, NC", route: "/cities/asheboro" },
    { name: "Passport courier services in Burlington, NC", route: "/burlington" },
    { name: "Passport courier services in Thomasville, NC", route: "/cities/thomasville" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Kernersville remotely via secure courier. We do not have a walk-in office in Kernersville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Forsyth County and the Piedmont Triad travelers.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Forsyth County and the Piedmont Triad including Guilford and Alamance counties",
  serviceAreaIntro: "From downtown Kernersville to the suburbs of Winston-Salem and Greensboro, from the High Point furniture district to the quiet communities of Thomasville and Archdale — Fast Passport Center serves the entire Kernersville region. We regularly help travelers from Clemmons, Lewisville, Jamestown, and Walkertown get their passports fast.",
  nearbyCitiesIntro: "We serve all Kernersville neighborhoods and the surrounding Piedmont Triad area including Winston-Salem, Greensboro, High Point, Thomasville, Archdale, Jamestown, Trinity, Clemmons, Lewisville, Walkertown, Asheboro, Burlington, Reidsville, Eden, and Mebane. If you are anywhere in Forsyth, Guilford, or Alamance counties, we have you covered.",
  howItWorksIntro: "Most Kernersville travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Kernersville travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Kernersville and Piedmont Triad travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Kernersville? Here are the most common ones we hear from Forsyth County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Kernersville international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Thomas H.",
      location: "Kernersville, NC",
      rating: 5,
      text: "My passport expired the week before a conference in Berlin. Fast Passport Center had my renewal in 5 days. Never had to leave the Triad. Excellent service.",
      service: "Passport Renewal",
    },
    {
      name: "Karen S.",
      location: "Kernersville, NC",
      rating: 5,
      text: "Emergency passport for a family medical emergency in Canada. Got it in 30 hours. The team was incredibly responsive and professional. True lifesavers.",
      service: "Emergency Passport",
    },
    {
      name: "Brandon M.",
      location: "Walkertown, NC",
      rating: 5,
      text: "Business trip to Dubai came up with 7 days notice. They got me a passport in 4 business days. The communication was outstanding throughout the process.",
      service: "Emergency Passport",
    },
    {
      name: "Nicole D.",
      location: "Clemmons, NC",
      rating: 5,
      text: "First passport for my son before his mission trip to Guatemala. Fast Passport Center helped us navigate every step. Ready in 5 days with zero stress.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "kernersville-1",
      name: "Kernersville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 E Mountain St",
      city: "Kernersville",
      state: "NC",
      zip: "27284",
      phone: "(336) 992-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Kernersville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Kernersville facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "kernersville-2",
      name: "Winston-Salem Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "251 N Main St",
      city: "Winston-Salem",
      state: "NC",
      zip: "27101",
      phone: "(336) 631-5183",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles west of Kernersville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Forsyth County. Full passport services. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "kernersville-3",
      name: "Greensboro Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 N Murrow Blvd",
      city: "Greensboro",
      state: "NC",
      zip: "27401",
      phone: "(336) 373-7825",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles east of Kernersville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Guilford County and eastern Triad. Less crowded than downtown.",
      icon: "ri-mail-line",
    },
    {
      id: "kernersville-4",
      name: "High Point Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1114 N Main St",
      city: "High Point",
      state: "NC",
      zip: "27262",
      phone: "(336) 882-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles south of Kernersville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves High Point and southern Guilford County. Full passport services.",
      icon: "ri-mail-line",
    },
    {
      id: "kernersville-5",
      name: "Forsyth County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "200 N Main St",
      city: "Winston-Salem",
      state: "NC",
      zip: "27101",
      phone: "(336) 779-6300",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "10 miles west of Kernersville",
      website: "https://www.forsyth.cc/",
      websiteLabel: "Forsyth County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "kernersville-6",
      name: "Walkertown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2921 Main St",
      city: "Walkertown",
      state: "NC",
      zip: "27051",
      phone: "(336) 595-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles north of Kernersville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Walkertown and northeast Forsyth County. Full passport services.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5+ hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Kernersville photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Forsyth County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Kernersville applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Forsyth County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Kernersville travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Kernersville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Kernersville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Kernersville before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Kernersville for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5+ hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Kernersville?", a: "Fast Passport Center offers fast passport renewal in Kernersville in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Kernersville?", a: "The nearest regional passport agency to Kernersville is the Atlanta Passport Agency, approximately 310 miles away via I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Kernersville without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Kernersville?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 5+ hours from Kernersville — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Forsyth County residents." },
    { q: "Do you serve the entire Piedmont Triad?", a: "Absolutely. Fast Passport Center serves the entire Piedmont Triad including Kernersville, Winston-Salem, Greensboro, High Point, Thomasville, Archdale, Jamestown, Trinity, Clemmons, Lewisville, Walkertown, Asheboro, Burlington, Reidsville, Eden, and Mebane. Our courier service works seamlessly from any address in Forsyth, Guilford, or Alamance counties." },
    { q: "Can I expedite a child passport in Kernersville?", a: "Yes. Fast Passport Center expedites child passports in Kernersville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Forsyth County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Kernersville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Kernersville", address: "120 E Mountain St, Kernersville, NC 27284", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Kernersville", address: "1010 S Main St, Kernersville, NC 27284", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Kernersville", address: "1130 S Main St, Kernersville, NC 27284", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Winston-Salem", address: "1001 S Stratford Rd, Winston-Salem, NC 27103", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Greensboro", address: "2504 Battleground Ave, Greensboro, NC 27408", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — High Point", address: "2630 N Main St, High Point, NC 27265", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Clemmons", address: "6361 Shallowford Rd, Clemmons, NC 27012", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Walkertown", address: "5380 Walkertown Commons Dr, Walkertown, NC 27051", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Kernersville",
      address: "150 W Mountain St, Kernersville, NC 27284",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Winston-Salem",
      address: "1100 S Stratford Rd, Winston-Salem, NC 27103",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Greensboro",
      address: "3411 W Wendover Ave, Greensboro, NC 27407",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Guilford County and the Greensboro area. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — High Point",
      address: "1624 N Main St, High Point, NC 27262",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Davidson County and southern Guilford County. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "10 miles east of Kernersville",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Primary airport for the Piedmont Triad. Direct flights to major domestic hubs with seasonal international routes. Only 15 minutes from Kernersville.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: true,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "80 miles east of Kernersville",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major alternative hub with additional international routes. Consider for long-haul international travel.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "85 miles southwest of Kernersville",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international hub. American Airlines hub with direct flights to Europe, Mexico, and the Caribbean. Consider for international travel from the Piedmont Triad.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { name: "NCDHHS Vital Records", url: "https://vitalrecords.nc.gov/", description: "North Carolina birth, death, marriage, and divorce certificates" },
    { name: "Forsyth County Register of Deeds", url: "https://www.forsyth.cc/rod/", description: "Birth, death, and marriage records for Forsyth County" },
    { name: "Forsyth County Superior Court", url: "https://www.nccourts.gov/locations/forsyth-county", description: "Divorce records and court documents for Forsyth County" },
  ],
};